module.exports = __webpack_public_path__ + "img/banner.398b1b8d.jpg";